if (!customElements.get('sr-cj-product')) {
  customElements.define('sr-cj-product', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const image = this.querySelector('.srcj__hero');
      const select = this.querySelector('select[name="id"]');
      const button = this.querySelector('.srcj__buy');
      const price = this.querySelector('.srcj__price');
      const caption = this.querySelector('.srcj__caption');
      const thumbnails = [...this.querySelectorAll('[data-image][type="button"]')];
      const showImage = (src, alt) => {
        if (!image || !src) return;
        image.removeAttribute('srcset'); image.src = src; image.alt = alt;
        if (caption) caption.textContent = alt;
      };
      thumbnails.forEach(thumb => thumb.addEventListener('click', () => {
        showImage(thumb.dataset.image, thumb.dataset.alt);
        thumbnails.forEach(item => item.setAttribute('aria-pressed', String(item === thumb)));
      }));
      const updateVariant = () => {
        if (!select) return;
        const option = select.selectedOptions[0];
        showImage(option.dataset.image, option.textContent.trim());
        thumbnails.forEach(item => item.setAttribute('aria-pressed', 'false'));
        if (price) price.textContent = option.dataset.price;
        if (button && this.dataset.ready === 'true') {
          button.disabled = option.dataset.available !== 'true';
          button.textContent = button.disabled ? 'Agotado' : 'Añadir al carrito';
        }
      };
      const variantData = this.querySelector('[data-srcj-variants]');
      if (variantData) {
        const variants = JSON.parse(variantData.textContent);
        const packs = [...this.querySelectorAll('lumin-product-qty-break')];
        const initial = variants.find(variant => String(variant.id) === this.dataset.initialVariant) || variants.find(variant => variant.available);
        const packButton = this.querySelector('button[name="add"]');
        const matchRow = row => {
          const values = [...row.querySelectorAll('select')].map(input => input.value);
          return variants.find(variant => variant.options.every((value, index) => value === values[index]));
        };
        const updateRow = row => {
          const inputs = [...row.querySelectorAll('select')];
          const values = inputs.map(input => input.value);
          inputs.forEach((input, index) => {
            [...input.options].forEach(option => {
              option.disabled = !variants.some(variant => variant.available && variant.options[index] === option.value && variant.options.every((value, other) => other === index || value === values[other]));
            });
          });
        };
        const updatePacks = () => {
          packs.forEach(pack => {
            const selected = [...pack.querySelectorAll('.lumin-product-block-qty-break-variant')].map(matchRow);
            const radio = pack.querySelector('input[type="radio"]');
            if (selected.every(Boolean)) radio.value = selected.map(variant => variant.id).join(',');
            if (radio.checked && packButton) packButton.disabled = !selected.every(variant => variant?.available);
          });
        };
        packs.forEach(pack => {
          pack.querySelectorAll('.lumin-product-block-qty-break-variant').forEach(row => {
            if (initial) row.querySelectorAll('select').forEach((input, index) => { input.value = initial.options[index]; });
            updateRow(row);
          });
        });
        updatePacks();
        const baseInput = this.querySelector('product-form input[name="id"]');
        if (baseInput && initial) baseInput.value = initial.id;
        this.addEventListener('change', event => {
          const row = event.target.closest('.lumin-product-block-qty-break-variant');
          if (row) {
            updateRow(row);
            const variant = matchRow(row);
            if (variant) {
              showImage(variant.image, variant.label);
              thumbnails.forEach(item => item.setAttribute('aria-pressed', 'false'));
            }
          }
          updatePacks();
        }, true);
      }
      select?.addEventListener('change', updateVariant);
      if (new URLSearchParams(window.location.search).has('variant')) updateVariant();
    }
  });
}
